module.exports = require('./$.global');


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-polyfill/~/core-js/modules/$.path.js
 ** module id = 271
 ** module chunks = 0
 **/